import { FC } from 'react';
import { ToggleButton, ToggleButtonGroup } from '../../uiLibraryImports';
import { ToggleButtonGroupProps } from './toggleButtonGroupTypes';
import globalColors from '../globalColors';

const ToggleButtonGroupContainer: FC<ToggleButtonGroupProps> = (props: ToggleButtonGroupProps) => {
    const { buttons, selectedButton, onSelect } = props;

    return (
        <ToggleButtonGroup value={selectedButton} exclusive aria-label="text alignment">
            {buttons.map(button => (
                <ToggleButton
                    key={button.name}
                    value={button.name}
                    aria-label={button.displayName}
                    onClick={() => onSelect(button.name)}
                    sx={{
                        padding: '0.4rem 2.5rem !important',
                        backgroundColor: `${globalColors.backgrounds.white} !important`,
                        color: `${globalColors.texts.grayed} !important`,
                        fontWeight: '500 !important',
                        '&&.MuiToggleButtonGroup-grouped': {
                            border: `1px solid ${globalColors.borders.grayed} !important`
                        },
                        '&&.MuiToggleButtonGroup-grouped:first-of-type': {
                            borderTopLeftRadius: '4px !important',
                            borderBottomLeftRadius: '4px !important'
                        },
                        '&&.MuiToggleButtonGroup-grouped:last-of-type': {
                            borderTopRightRadius: '4px !important',
                            borderBottomRightRadius: '4px !important'
                        },
                        '&&.Mui-selected': {
                            border: `1px solid ${globalColors.borders.strong} !important`,
                            background: `${globalColors.backgrounds.lightPurple} !important`,
                            color: `${globalColors.texts.strong} !important`
                        },
                        '&&.Mui-selected + &&.MuiToggleButtonGroup-grouped': {
                            borderLeft: `1px solid ${globalColors.borders.strong} !important`,
                            marginLeft: '0 !important'
                        },
                        '&&:hover': {
                            border: `1px solid ${globalColors.borders.strongHovered} !important`,
                            background: `${globalColors.backgrounds.pinkGradient} !important`,
                            color: `${globalColors.texts.strongHovered} !important`
                        },
                        '&&:hover + &&': {
                            borderLeft: `1px solid ${globalColors.borders.strongHovered} !important`
                        }
                    }}
                >
                    {button.displayName}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default ToggleButtonGroupContainer;
